module.exports = __webpack_public_path__ + "static/media/prototype.288186dc.JPG";